import { handleActions } from 'redux-actions';

import { API_CALL_STARTED, API_CALL_FINISHED } from '../constants/Constants';

const initialState = {
  loading: false,
  callCount: 0
};

export default handleActions(
  {
    [API_CALL_STARTED]: ({ callCount }) => ({ loading: true, callCount: callCount + 1 }),
    [API_CALL_FINISHED]: ({ callCount }) => ({ loading: callCount - 1 > 0, callCount: callCount - 1 })
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/reducers/LoaderReducer.js